<template>
  <v-card :loading="loading" :disabled="loading">
    <v-form @submit.prevent="handleSubmit()">
      <v-card-title>Detalhes Pagamento</v-card-title>
      <v-card-subtitle>
        {{ form.id }}
      </v-card-subtitle>
      <v-card-text>
        <v-row v-if="form.id">
          <v-col>
            <v-btn @click="$emit('delete', form.id)" outlined color="red">
              <v-icon left>mdi-delete</v-icon>
              Excluir
            </v-btn>
          </v-col>
        </v-row>
        <MoneyInput
          @keydown.enter="handleSubmit()"
          v-model="form.amount"
          label="Valor"
          autofocus
        ></MoneyInput>
        <Timestamp
          v-model="form.sent_at"
          :date.sync="send_date"
          :time.sync="send_time"
        >
          <v-row>
            <v-col>
              <v-text-field
                type="date"
                v-model="send_date"
                label="Data do envio"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="send_time"
                label="Hora"
                type="time"
              ></v-text-field>
            </v-col>
          </v-row>
        </Timestamp>
        <v-row>
          <v-col>
            <v-file-input
              v-model="uploadProof"
              label="Comprovante"
            ></v-file-input>
          </v-col>
          <v-col>
            <v-file-input
              v-model="uploadInvoice"
              label="Nota Fiscal"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-chip
              v-if="form.has_proof"
              :href="`${form.proof_url}`"
              :disabled="!form.proof_url"
            >
              <v-icon size="18" left>mdi-paperclip</v-icon>
              Comprovante
            </v-chip>
            <v-chip
              v-if="form.has_proof"
              :href="`${form.invoice_url}`"
              :disabled="!form.invoice_url"
              class="ml-2"
            >
              <v-icon size="18" left>mdi-paperclip</v-icon>
              Nota Fiscal
            </v-chip>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleClickCancel()" text>Cancelar</v-btn>
        <v-btn type="submit" text color="primary">Salvar</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Timestamp from "@/components/tools/Timestamp";
import MoneyInput from "@/components/MoneyInput";

export default {
  components: { Timestamp, MoneyInput },
  data() {
    return {
      form: {},
      send_date: "",
      send_time: "",
      loading: false,
      uploadProof: null,
      uploadInvoice: null,
    };
  },
  methods: {
    setLoading(value) {
      this.loading = value;
    },
    reset() {
      this.form = {};
      this.send_date = "";
      this.send_time = "";
      this.uploadProof = null;
      this.uploadInvoice = null;
    },
    fill(data) {
      this.form = { ...data };
    },
    handleClickCancel() {
      this.$emit("cancel");
    },
    handleSubmit() {
      this.$emit("submit", {
        form: this.form,
        proof: this.uploadProof,
        invoice: this.uploadInvoice,
      });
    },
  },
};
</script>